export const INITIAL_HELP_REQUEST = "INITIAL_HELP_REQUEST";
export const FINAL_HELP_REQUEST = "FINAL_HELP_REQUEST";

export const FETCH_HELP_CENTER_SUCCESS = "FETCH_HELP_CENTER_SUCCESS";
export const SAVE_HELP_CENTER_SUCCESS = "SAVE_HELP_CENTER_SUCCESS";
export const DELETE_HELP_CENTER_SUCCESS = "DELETE_HELP_CENTER_SUCCESS";

export const ERROR = "ERROR";
